module.exports = __webpack_public_path__ + "static/media/proyectos.7a18cd76.svg";